export { CodePage as default } from '@/components/pages/Legal/CodeConduct'
